(function() {
    /* globals $, angular */
    'use strict';

    angular.module('dashboardApp').controller('usageTrackerController', Controller);
    Controller.$inject = [
        '$q',
        '$scope',        
        'Login',
        'Apps',
        'UsageTracker',
        'Routing'
    ];

    function Controller (
        $q,
        $scope,
        Login,
        Apps,
        UsageTracker,
        Routing
    ) {

        var vm = this;
        var defaultApp = {id: -1, name: '[All]'};
        var defaultUser = {id: -1, name: '[All]'};
        var today = new Date();
        var dtFormat = "YYYY-MM-DD";
        

        vm.showProgress = true;
        vm.showError = false;

        vm.apps = [ defaultApp ];
        vm.app = vm.apps[0];

        vm.users = [ defaultUser ];
        vm.user = vm.users[0];

        vm.onSubmit = loadData;

        vm.usageData = null;
        vm.loginCounts = null;

        vm.date = {
            startDate: moment().subtract(14, 'days'),
            endDate: moment()
        };

        vm.datePickerOptions = {
            locale: {                
                format: dtFormat
            },
            ranges: {                
                'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                'Last 90 Days': [moment().subtract(89, 'days'), moment()],
                'Last 6 Months': [moment().subtract(6, 'months'), moment()],
                'Last 1 Year': [moment().subtract(1, 'years'), moment()]
            },
            opens: 'left',
            showDropdowns: true,
            linkedCalendars: false,
            showCustomRangeLabel: false,
            alwaysShowCalendars: true
        };


        vm.export = function() {
	        UsageTracker.export(
		        vm.user.id,
		        vm.app.id,
		        vm.date.startDate.format(dtFormat),
		        vm.date.endDate.format(dtFormat)
	        );
        };


        function loadFilters() {
            vm.showProgress = true;
            vm.showError = false;

            var promises = [
                Apps.list(),
                UsageTracker.userList()
            ];

            $q.all(promises).then(function(responses) {
                parseFilters(responses[0], responses[1]);

            }, function() {
                vm.showProgress = false;
                vm.showError = true;
            });
        }



        function parseFilters(apps, users) {
            vm.apps = [ defaultApp ].concat(apps);
            vm.users = [ defaultUser ].concat(users);
            vm.showProgress = false;
        }



        function loadData() {
            vm.showProgress = true;
            vm.showError = false;

            var promises = [
                UsageTracker.usageData(
                    vm.user.id,
                    vm.app.id,
                    vm.date.startDate.format(dtFormat),
                    vm.date.endDate.format(dtFormat)
                ),
                UsageTracker.loginCounts(
                    vm.user.id,
                    vm.app.id,
                    vm.date.startDate.format(dtFormat),
                    vm.date.endDate.format(dtFormat)
                )
            ];

            $q.all(promises).then(function(responses) {
                vm.showProgress = false;
                processData(responses[0], responses[1]);

            }, function() {
                vm.showProgress = false;
                vm.showError = true;
            });
        }



        function processData(usageData, loginCounts) {
            vm.usageData = usageData;
            vm.loginCounts = loginCounts;
        }



        //----------- initialization ------------------

        function init() {
            Login.check().then(function(success) {
                if (success) {
                    loadFilters();
                } else {
                    Routing.login();
                }
            });
        }


        init();


    }



})();
